import React from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import CreateJobDefinition from './CreateJobDefinition';

class JobDefinitionSelector extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.jobTitleDefault = "Please select a Job Definition to configure";
        this.state = {
            sbJobTitle: this.jobTitleDefault
        };
        this.jobDefinitionChangeHandler = this.jobDefinitionChangeHandler.bind(this);
        this.selectItem = this.selectItem.bind(this);
    }
    jobDefinitionChangeHandler(jobDefinitionID) {
        let selectedJob = null
        if (this.props.currentExtraction?.job_definitions) {
            selectedJob = this.props.currentExtraction.job_definitions.find((jd) => jd.id == jobDefinitionID);
        }
        if (selectedJob) {
            this.setState({ sbJobTitle: selectedJob.job_reference });
        } else {
            this.setState({ sbJobTitle: this.jobTitleDefault });
        }
        this.props.onJobDefinitionChange(selectedJob);
    }
    selectItem(jobDefinition) {
        this.jobDefinitionChangeHandler(jobDefinition?.id);
    }
    render() {
        const jobDefinitionsSet = this.props.currentExtraction?.job_definitions != null;
        return (
            <>
                <div style={{ display: jobDefinitionsSet ? 'block' : 'none' }}>
                    <ReactBootstrap.Dropdown onSelect={this.jobDefinitionChangeHandler}>
                        <ReactBootstrap.Dropdown.Toggle id="job-drop-down" variant="light"  >
                            {this.state.sbJobTitle}
                        </ReactBootstrap.Dropdown.Toggle>
                        <ReactBootstrap.Dropdown.Menu>
                            {/* "Create New" option with green font */}
                            <ReactBootstrap.Dropdown.Item
                                style={{
                                    color: 'var(--bs-success)', // Success variant color
                                    transition: 'color 0.3s', // Smooth color transition
                                }}
                                disabled={!jobDefinitionsSet}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.createJobDefinitionControl.showHandler();  // Show the modal
                                }}
                            >
                                Create a new Job Definition
                            </ReactBootstrap.Dropdown.Item>
                            
                            {/* Separator line */}
                            <ReactBootstrap.Dropdown.Divider />

                            {/* Job Definitions */}
                            {this.props.currentExtraction?.job_definitions != null && this.props.currentExtraction?.job_definitions.map((jobDefinition, i) => (
                            <ReactBootstrap.Dropdown.Item key={jobDefinition.id} eventKey={jobDefinition.id}>
                                {jobDefinition.job_reference}
                            </ReactBootstrap.Dropdown.Item>
                            ))}
                        </ReactBootstrap.Dropdown.Menu>
                    </ReactBootstrap.Dropdown>
                </div>
                <CreateJobDefinition 
                    ref={instance => { this.createJobDefinitionControl = instance; }} 
                    jobDefinitionService={this.props.jobDefinitionService} 
                    onJobDefinitionCreated={(jobDefinition) => this.props.onJobDefinitionCreated(jobDefinition)}
                    extraction={this.props.currentExtraction}
                />
            </>
        );
    }
}

export default JobDefinitionSelector;